import { ConfigProvider, App as AntApp } from "antd";
import ErrorBoundary from "./components/ErrorBoundary";
import PageLoader from "./components/PageLoader";
import TrailingSlashRedirect from "./components/TrailingSlashRedirect";
import { antTheme } from "./config/theme";
import { AppRoutes } from "./routes/routes.exports";
import { Suspense } from "react";
import { PopupProvider } from "./context/PopupContext";

function App() {
  return (
    <ErrorBoundary>
      <ConfigProvider theme={antTheme}>
        <AntApp>
          <TrailingSlashRedirect />
          <Suspense fallback={<PageLoader />}>
            <PopupProvider>
              <AppRoutes />
            </PopupProvider>
          </Suspense>
        </AntApp>
      </ConfigProvider>
    </ErrorBoundary>
  );
}

export default App;
